import React from "react";
import { getDateFromEpoch } from "../../services/dateService";

export const TableChart = ({ dataSet, def }) => {
	const borderClass = def.format.hideBorders
		? ""
		: `border border-${def.format.colours.grid}-200`;

	const headings = def.format.columns.map((e) => {
		let width = "";
		if (e.hasUnit === true) {
			width = "w-1/4";
		} else if (e.isDate === true) {
			width = "w-1/6";
		}

		return (
			<th key={e.key} className={`${borderClass} ${width}`}>
				{e.title}
			</th>
		);
	});

	const rows = dataSet.data.map((e, rowIndex) => {
		const cells = def.format.columns.map((w, colIndex) => {
			let value = e[w.key];

			if (w.isDate === true) {
				const date = getDateFromEpoch(value).getUTCDate();
				value = `${date < 10 ? 0 : ""}${date}`;
			}

			if (def.format.unit && w.hasUnit === true) {
				value = (
					<div className={"flex justify-between"}>
						<span className={"block"}>{def.format.unit}</span>{" "}
						<span className={"block"}>{value.toFixed(2)}</span>
					</div>
				);
			}

			return (
				<td
					key={`cell_${rowIndex}_${colIndex}`}
					className={`px-1 py-1 md:py-2 ${borderClass}`}
				>
					{value}
				</td>
			);
		});
		return <tr key={`row_${rowIndex}`}>{cells}</tr>;
	});

	if (!rows || !rows.length) {
		return <div className="mt-4 text-center text-base">No data available</div>;
	}

	return (
		<>
			<table
				className={`w-full text-xs xs:text-sm table-fixed border-collapse ${borderClass}`}
			>
				<thead>
					<tr className={"bg-trans-blk"}>{headings}</tr>
				</thead>
				<tbody className={`text-${def.format.colours.text}`}>{rows}</tbody>
			</table>
		</>
	);
};
